import { Schema as S } from "effect";

export const GetAvailableTimeSlotsRequestSchema = S.Struct({
  scheduleTypeId: S.String,
  startDate: S.String,
  endDate: S.String,
});

export type GetAvailableTimeSlotsRequest = S.Schema.Type<
  typeof GetAvailableTimeSlotsRequestSchema
>;
